module.exports = __webpack_public_path__ + "img/img-ae9ccf.png";